import * as React from 'react';
import {FunctionComponent, useEffect, useState} from 'react';
import {classNames} from '../Support/classNames';

interface OwnProps {
    text: any;
    onClick: () => void;
    loading?: boolean;
    className?: string;
    disabled?: boolean;
}

export const Button: FunctionComponent<OwnProps> = ({text, onClick, loading, className, disabled}) => {
    const [showLoadingStart, setShowLoadingStart] = useState<number | false>(false);

    useEffect(() => {
        let timeout: NodeJS.Timeout | undefined;
        if (loading === undefined) {
            setShowLoadingStart(false);
            return;
        }
        //Show loader minimum 500ms
        if (loading) {
            setShowLoadingStart(Date.now());
        } else {
            if (showLoadingStart === false) {
                setShowLoadingStart(false);
                return;
            }
            const timeToWait = 500 - (Date.now() - showLoadingStart);
            if (timeToWait > 0) {
                timeout = setTimeout(() => {
                    setShowLoadingStart(false);
                }, timeToWait);
            } else {
                setShowLoadingStart(false);
            }
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [loading]);

    return (
        <button
            className={classNames(className, 'btn')}
            disabled={showLoadingStart !== false || disabled}
            onClick={() => {
                if (showLoadingStart === false) {
                    onClick();
                }
            }}
        >
            {showLoadingStart !== false ? <span className="spinner-grow spinner-grow-sm" /> : text}
        </button>
    );
};
